import React, {useRef, useState} from "react";
import {useDropzone} from "react-dropzone";
import ImageIcon from "../../icons/ImageIcon";
import CloseX from "../../icons/CloseX";
import dataLayerHandler from "../../../components/dataLayerHandler";

const GetQuote = ({product, closePopup}) => {
  const enquireForm = useRef(null);
  const [files, setFiles] = useState([]);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [enquireLoading, setEnquireLoading] = useState(false);
  const [completed, setCompleted] = useState(false);

  const onDrop = (acceptedFiles) => {
    const newFiles = acceptedFiles.filter(
      (newFile) => !files.some((existingFile) => existingFile.name === newFile.name)
    );
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    accept: 'image/*',
    multiple: true,
  });

  const handleRemove = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (enquireLoading) {
      return false;
    }

    const data = new FormData(enquireForm.current);

    files.forEach((file) => {
      data.append("UploadedFiles[]", file);
    });

    setEnquireLoading(true);
    setCompleted(false);

    fetch('quote/submit', {
      method: 'POST',
      body: data
    }).then((response) => {
      if (response.ok) {
        setEnquireLoading(false);
        setCompleted(true);
        dataLayerHandler('quote_submitted', 'Quote for: ' + product.title);
        enquireForm.current.reset();
        setFiles([]);
        setTimeout(() => {
          setPopupOpen(false);
        }, 5000);
      } else {
        console.error('Error:', response.statusText);
        setEnquireLoading(false);
      }
    })
      .catch((error) => {
        console.error('Fetch error:', error);
        setEnquireLoading(false);
      });
    return false;
  };

  return (
    <>
      <div className="getQuote">
        <div className="getQuote__wrap">

          {completed && <p className="success-msg">
            Thanks for your enquiry. Expect a response soon! <button className="close-btn" onClick={closePopup}>
            <CloseX/></button>
          </p>}

          {!completed && <>
            <div className="getQuote__title">
              <h2>Enquire</h2>
              <button className="close-btn" onClick={closePopup}><CloseX/></button>
            </div>
            <div className="getQuote__intro">
              {product.is_skinned_site ? (
                <p>To get a quote, fill out the form below. We'll then come back to you with pricing</p>
              ) : (
                <p>Simply fill in the form below and we'll be in touch.
                </p>
              )}

            </div>
            <div className="getQuote__form">

              <form method={'post'} onSubmit={onSubmit} ref={enquireForm}>

                <div className="getQuote__form__field getQuote__form__field--inline">
                  <label>Your Name*</label>
                  <input type="text" name={'Name'} id={'Name'} required/>
                </div>
                <div className="getQuote__form__field getQuote__form__field--inline">
                  <label>Your Email*</label>
                  <input type="email" name={'Email'} id={'Email'} required/>
                </div>
                <div className="getQuote__form__field getQuote__form__field--inline">
                  <label>Your Phone Number*</label>
                  <input type="tel" name={'Phone'} id={'Phone'} required/>
                </div>
                <div className="getQuote__form__field getQuote__form__field--inline">
                  <label>Your Postcode*</label>
                  <input type="text" name={'Postcode'} id={'Postcode'} required/>
                </div>
                <div className="getQuote__form__field getQuote__form__field--inline">
                  <label>Garment*</label>
                  <input type="text" name={'Garment'} id={'Garment'} defaultValue={product.title} required/>
                </div>
                <div className="getQuote__form__field getQuote__form__field--inline">
                  <label>Quantity*</label>
                  <input type="text" name={'Quantity'} id={'Quantity'} required/>
                </div>
                <div className="getQuote__form__field getQuote__form__comment">
                  <p>
                  Comments. For example, 'Small logo on left chest' (or anything else you want to tell us!).
                  </p>
                  <textarea name={'Comment'} id={'Comment'}/>
                </div>
    
                <input type="hidden" name={'ProductID'} id={'ProductID'} value={product.id} required/>

                <button className="btn btn--black">Submit Enquiry</button>
              </form>

            </div>
          </>}
        </div>
      </div>
    </>
  );
};

export default GetQuote;
